// extracted by mini-css-extract-plugin
export var statItem = "_dz-1";
export var statsRow = "_dz-0";